<script lang="ts" setup>
	import { useResourcesApi } from '~/services/apis/resources'

	const { getHospitalList, getStatesWithLGA } = useResourcesApi()
	const props = defineProps<{
		productId: string
	}>()
	const searchValue = shallowRef('')
	const filterState = shallowRef('all states')
	const filterBy = shallowRef('hospital')
	const medicalDropdown = ref([
		{
			label: 'Hospital',
			value: 'hospital'
		},

		{
			label: 'Eye care',
			value: 'ophthalmology'
		},
		{
			label: 'Dental',
			value: 'dental'
		},
		{
			label: 'Clinic',
			value: 'laboratory centres'
		},
		{
			label: 'Diagnostics',
			value: 'diagnostic centres'
		}
	])
	const totalHospitalValue = shallowRef(0)
	const { StatesWithLga } = reactor(useUser())
	const hospitalList = ref<HospitalListResponse['items']>([])
	const loadingTable = shallowRef(true)

	const tableRowClass = 'text-gray-600 text-sm font-medium capitalize !p-2'
	const activeList = computed(() => medicalDropdown.value.find(item => item.value === filterBy.value)?.label || '')
	const tableColumns = computed<TableColumn>(() => [
		{
			title: 'S/N',
			dataIndex: 'sn',
			key: 'sn',
			customCell: () => ({ class: `${tableRowClass} text-center` }),
			width: '50px',
			class: '!text-sm !py-3 !px-2'
		},
		{
			title: `${totalHospitalValue.value} ${activeList.value}${(totalHospitalValue.value > 1 && 's') || ''}`,
			dataIndex: 'hospital',
			key: 'hospital',
			customCell: () => ({ class: tableRowClass }),
			class: 'text-sm !py-2 !px-3',
			width: 250
		},
		{
			title: 'States',
			dataIndex: 'location',
			key: 'location',
			customCell: () => ({ class: tableRowClass }),
			class: '!text-sm !py-2 !px-3'
		},
		{
			title: 'Details',
			dataIndex: 'details',
			key: 'details',
			customCell: () => ({ class: tableRowClass }),
			class: '!text-sm !py-2 !px-3 text-center'
		}
	])
	// const getMedicalList = async () => {
	//     try {
	//         loadingTable.value = true
	//         const result = await getHospitalList({
	//             location: filterState.value === 'all states' ? '' : filterState.value,
	//             type: filterBy.value,
	//             search: searchValue.value,
	//             product_id: props.productId || '',
	//             user_type: 'business'
	//         })
	//         if (result.value?.data) {
	//             totalHospitalValue.value = result.value.data.total_count || 0
	//             hospitalList.value = result.value.data.items
	//         }
	//     } finally {
	//         loadingTable.value = false
	//     }
	// }

	// onBeforeMount(() => {
	//     resolve(async () => {
	//         await Promise.allSettled([getStatesWithLGA(), getMedicalList()])
	//     })
	// })
</script>

<template>
	<div>
		<div class="flex h-[48px] w-full items-center rounded-md border px-4">
			<forms-search-field v-model:value="searchValue" class="flex-1 pr-3" :use-custom-class="false" />
			<div class="max-w-[150px] overflow-hidden overflow-x-auto text-ellipsis border-r">
				<a-select
					v-model:value="filterState"
					class="custom-select max-w-sm flex-none border-0 border-l capitalize"
					:options="[{ label: 'All States', value: 'all states' }, ...StatesWithLga]"
					:use-default-class="false"
					show-search
				/>
			</div>

			<a-select
				v-model:value="filterBy"
				class="custom-select"
				:options="medicalDropdown"
				:use-default-class="false"
				@change="getMedicalList"
			/>
		</div>

		<div class="table-wrapper mt-8 overflow-x-auto">
			<shared-table-loader v-slot="{ columns }" :columns="tableColumns" :loading="loadingTable">
				<a-table :columns="columns" :loading="loadingTable" :data-source="hospitalList" :scroll="{ y: 440 }">
					<template #headerCell="{ column }">
						<span class="text-[13px] font-medium text-gray-600">{{ column.title }}</span>
					</template>
					<template #bodyCell="{ column, index, record }">
						<span v-if="column.key === 'sn'">{{ index + 1 }}</span>
						<div v-if="column.key === 'hospital'" class="space-y-2">
							<span class="text-[13px] font-medium text-gray-600">{{ record?.name || '---' }}</span>
							<p class="text-xs text-gray-500">({{ record?.address || '--' }})</p>
						</div>
						<a
							v-if="column.key === 'details'"
							:href="`https://www.google.com/maps/search/?api=1&query=${record?.address}`"
							class="text-center text-xs font-medium text-primary-2"
							target="_blank"
						>
							Direction
						</a>
					</template>
				</a-table>
			</shared-table-loader>
		</div>
	</div>
</template>

<style scoped>
	.custom-select:deep(.ant-select-selector) {
		@apply min-w-[120px] !border-none !bg-transparent !px-5 tracking-wide;
	}
</style>
